<div class=" py-2 px-0 px-lg-2">
    <div class="section-menu-items">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['banner-config']"
        routerLinkActive="router-link-active"
      >
  
      </button>
      </div>
  
    <router-outlet></router-outlet>
  </div>
  
  